interface Copsoq3Option {
  label: string;
  score: number;
}

export interface Copsoq3Question {
  name: string;
  question: string;
  echelle: string;
  domaine: string;
  options: Copsoq3Option[];
}

export const copsoq3Questions: Copsoq3Question[] = [
  {
    name: "Q01",
    question: "Savez-vous précisément ce que l'on attend de vous dans votre activité de SP ?",
    echelle: "Clarté des rôles",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q02",
    question: "Les agents peuvent-ils faire confiance aux informations venant de la ligne managériale ?",
    echelle: "Confiance entre les salariés et le management",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q03",
    question: "Les contraintes dans votre activité de SP interfèrent-elles avec votre vie privée et familiale ?",
    echelle: "Conciliation entre vie privée et vie professionnelle",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Dans une très faible mesure", score: 4 },
      { label: "Dans une faible mesure", score: 3 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 1 },
      { label: "Dans une très grande mesure", score: 0 },
    ],
  },
  {
    name: "Q04",
    question: "Votre activité de SP nécessite-t-elle que vous preniez des initiatives ?",
    echelle: "Possibilités d'épanouissement",
    domaine: "Autonomie",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q05",
    question: "Y a-t-il une bonne coopération entre les agents de votre unité ?",
    echelle: "Confiance et coopération entre collègues",
    domaine: "Relations entre collègues",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q06",
    question: "Votre responsable hiérarchique accorde-t-il (elle) une priorité à la satisfaction au travail ?",
    echelle: "Qualité de leadership du responsable hiérarchique",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q07",
    question: "Votre activité de SP a-t-elle des objectifs clairs ?",
    echelle: "Clarté des rôles",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q08",
    question: "Avez-vous le sentiment que votre activité de SP vous prend tellement de temps que cela a un impact négatif sur votre vie privée ?",
    echelle: "Conciliation entre vie privée et vie professionnelle",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Dans une très faible mesure", score: 4 },
      { label: "Dans une faible mesure", score: 3 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 1 },
      { label: "Dans une très grande mesure", score: 0 },
    ],
  },
  {
    name: "Q09",
    question: "Êtes-vous inquiet (ète) à l’idée de perdre votre activité de SP ?",
    echelle: "Insécurité professionnelle",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Dans une très faible mesure", score: 4 },
      { label: "Dans une faible mesure", score: 3 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 1 },
      { label: "Dans une très grande mesure", score: 0 },
    ],
  },
  {
    name: "Q10",
    question: "Votre travail de SP est-il reconnu et apprécié par le management ?",
    echelle: "Reconnaissance",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q11",
    question: "Avez-vous le sentiment que le travail que vous faites comme SP est important ?",
    echelle: "Sens du travail",
    domaine: "Vécu professionnel",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q12",
    question: "Pouvez-vous utiliser vos compétences ou votre expertise dans votre activité de SP ?",
    echelle: "Possibilités d'épanouissement",
    domaine: "Autonomie",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q13",
    question: "Dans l’ensemble, les agents se font-ils confiance entre eux ?",
    echelle: "Confiance et coopération entre collègues",
    domaine: "Relations entre collègues",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q14",
    question: "Craignez-vous d’être muté(e) à un autre poste de travail contre votre volonté ?",
    echelle: "Insécurité professionnelle",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Dans une très faible mesure", score: 4 },
      { label: "Dans une faible mesure", score: 3 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 1 },
      { label: "Dans une très grande mesure", score: 0 },
    ],
  },
  {
    name: "Q15",
    question: "Avez-vous le sentiment que l'unité dans laquelle vous exercez votre activité de SP est d’une grande importance pour vous ?",
    echelle: "Engagement dans l'entreprise",
    domaine: "Vécu professionnel",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q16",
    question: "Votre responsable hiérarchique est-il (elle) compétent(e) dans la résolution des conflits ?",
    echelle: "Qualité de leadership du responsable hiérarchique",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q17",
    question: "Dans votre activité de SP, devez-vous avoir l’œil sur beaucoup de choses ?",
    echelle: "Exigences cognitives",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q18",
    question: "Travaillez-vous à une cadence élevée dans votre activité de SP ?",
    echelle: "Rythme de travail",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q19",
    question: "Etes-vous informé(e) suffisamment à l’avance au sujet de décisions importantes, de changements ou de projets à venir ?",
    echelle: "Prévisibilité",
    domaine: "Organisation et Management",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q20",
    question: "Recevez-vous de l’aide et du soutien de votre responsable hiérarchique lorsque vous en avez besoin ?",
    echelle: "Soutien de la part du responsable hiérarchique",
    domaine: "Organisation et Management",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q21",
    question: "Votre activité de SP vous place-t-elle dans des situations déstabilisantes sur le plan émotionnel ?",
    echelle: "Exigences émotionnelles",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q22",
    question: "Prenez-vous du retard dans votre activité ?",
    echelle: "Charge de travail",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q23",
    question: "Dans votre activité de SP, êtes-vous soumis(e) à des demandes contradictoires ?",
    echelle: "Conflit de valeurs",
    domaine: "Organisation et Management",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q24",
    question: "Devez-vous faire face aux problèmes des autres dans le cadre de votre activité de SP ?",
    echelle: "Exigences émotionnelles",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q25",
    question: "Devez-vous travailler très rapidement ?",
    echelle: "Rythme de travail",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q26",
    question: "Recevez-vous de l’aide et du soutien de la part de vos collègues lorsque vous en avez besoin ?",
    echelle: "Soutien de la part des collègues",
    domaine: "Relations entre collègues",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q27",
    question: "Votre activité de SP exige-t-elle que vous vous souveniez de beaucoup de choses ?",
    echelle: "Exigences cognitives",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q28",
    question: "Vous arrive-t-il de manquer de temps pour accomplir toutes vos tâches de SP ?",
    echelle: "Charge de travail",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q29",
    question: "Vos collègues se montrent-ils à l’écoute de vos problèmes professionnels lorsque vous en avez besoin ?",
    echelle: "Soutien de la part des collègues",
    domaine: "Relations entre collègues",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q30",
    question: "Recevez-vous toutes les informations dont vous avez besoin pour bien faire votre activité ?",
    echelle: "Prévisibilité",
    domaine: "Organisation et Management",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q31",
    question: "Votre activité de SP est-elle éprouvante sur le plan émotionnel ?",
    echelle: "Exigences émotionnelles",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q32",
    question: "Est-il nécessaire de maintenir un rythme soutenu dans votre activité de SP ?",
    echelle: "Rythme de travail",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q33",
    question: "Dans l’ensemble, le management fait-il confiance aux agents quant à leur capacité à bien faire leur travail ?",
    echelle: "Confiance entre les salariés et le management",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q34",
    question: "Avez-vous une grande influence sur les prises de décisions par rapport à votre activité de SP ?",
    echelle: "Marge de manœuvre",
    domaine: "Autonomie",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q35",
    question: "Votre responsable hiérarchique est-il (elle) compétent(e) dans la planification du travail ?",
    echelle: "Qualité de leadership du responsable hiérarchique",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q36",
    question: "Votre activité de SP vous donne-t-elle la possibilité d’apprendre des choses nouvelles ?",
    echelle: "Possibilités d'épanouissement",
    domaine: "Autonomie",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q37",
    question: "Avez-vous le sentiment que votre activité de SP vous prend tellement d’énergie que cela a un impact négatif sur votre vie privée ?",
    echelle: "Conciliation entre vie privée et vie professionnelle",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Dans une très faible mesure", score: 4 },
      { label: "Dans une faible mesure", score: 3 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 1 },
      { label: "Dans une très grande mesure", score: 0 },
    ],
  },
  {
    name: "Q38",
    question: "Les conflits sont-ils résolus de manière équitable ?",
    echelle: "Justice organisationnelle",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q39",
    question: "Pouvez-vous intervenir sur la quantité de travail qui vous est attribuée ?",
    echelle: "Marge de manœuvre",
    domaine: "Autonomie",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q40",
    question: "Votre activité de SP a-t-elle du sens pour vous ?",
    echelle: "Sens du travail",
    domaine: "Vécu professionnel",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q41",
    question: "Êtes-vous inquiet (ète) à l’idée de rencontrer des difficultés à trouver une autre activité si vous perdiez celle de SP ?",
    echelle: "Insécurité professionnelle",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Dans une très faible mesure", score: 4 },
      { label: "Dans une faible mesure", score: 3 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 1 },
      { label: "Dans une très grande mesure", score: 0 },
    ],
  },
  {
    name: "Q42",
    question: "Le travail est-il réparti équitablement ?",
    echelle: "Justice organisationnelle",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q43",
    question: "Recommanderiez-vous à quelqu’un de postuler sur un poste dans votre unité ?",
    echelle: "Engagement dans l'entreprise",
    domaine: "Vécu professionnel",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q44",
    question: "Y a-t-il une bonne ambiance entre vous et vos collègues ?",
    echelle: "Confiance et coopération entre collègues",
    domaine: "Relations entre collègues",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q45",
    question: "Etes-vous traité(e) équitablement dans votre activité de SP ?",
    echelle: "Reconnaissance",
    domaine: "Organisation et Management",
    options: [
      { label: "Dans une très faible mesure", score: 0 },
      { label: "Dans une faible mesure", score: 1 },
      { label: "Plus ou moins", score: 2 },
      { label: "Dans une grande mesure", score: 3 },
      { label: "Dans une très grande mesure", score: 4 },
    ],
  },
  {
    name: "Q46",
    question: "Devez-vous faire des choses qui auraient dû être faites autrement ?",
    echelle: "Conflit de valeurs",
    domaine: "Organisation et Management",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q47",
    question: "Votre responsable hiérarchique est-il(elle) disposé(e) à vous écouter au sujet de vos problèmes professionnels lorsque vous en avez besoin ?",
    echelle: "Soutien de la part du responsable hiérarchique",
    domaine: "Organisation et Management",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q48",
    question: "Disposez-vous d’un temps suffisant pour accomplir vos tâches de SP  ?",
    echelle: "Charge de travail",
    domaine: "Contraintes quantitatives",
    options: [
      { label: "Jamais", score: 0 },
      { label: "Rarement", score: 1 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 3 },
      { label: "Toujours", score: 4 },
    ],
  },
  {
    name: "Q49",
    question: "A quel point êtes-vous satisfait(e) de votre activité de SP dans son ensemble ?",
    echelle: "Satisfaction au travail",
    domaine: "Vécu professionnel",
    options: [
      { label: "Pas satisfait(e) du tout", score: 0 },
      { label: "Pas satisfait(e)", score: 1 },
      { label: "Satisfait(e)", score: 2 },
      { label: "Très satisfait(e)", score: 3 },
    ],
  },
  {
    name: "Q50",
    question: "Cette question porte sur votre état au cours des 4 dernières semaines : A quelle fréquence vous êtes-vous senti(e) à bout de force ?",
    echelle: "Epuisement",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q51",
    question: "Cette question porte sur votre état au cours des 4 dernières semaines : A quelle fréquence avez-vous été irritable ?",
    echelle: "Stress",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q52",
    question: "Cette question porte sur votre état au cours des 4 dernières semaines : A quelle fréquence avez-vous été émotionnellement épuisé(e) ?",
    echelle: "Epuisement",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q53",
    question: "Cette question porte sur votre état au cours des 4 dernières semaines : A quelle fréquence avez-vous été stressé(e) ?",
    echelle: "Stress",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Jamais", score: 4 },
      { label: "Rarement", score: 3 },
      { label: "Parfois", score: 2 },
      { label: "Souvent", score: 1 },
      { label: "Toujours", score: 0 },
    ],
  },
  {
    name: "Q54",
    question: "En général, diriez-vous que votre santé est :",
    echelle: "Santé auto évaluée",
    domaine: "Santé et Bien-être",
    options: [
      { label: "Mauvaise", score: 0 },
      { label: "Plutôt mauvaise", score: 1 },
      { label: "Plus ou moins bonne", score: 2 },
      { label: "Bonne", score: 3 },
      { label: "Excellente", score: 4 },
    ],
  },
];
